export default {
    LOADING: 'CC_LOADING',
    DATA_LOADED: 'CC_DATA_LOADED'
}


// WEBPACK FOOTER //
// ./App/components/modules/chainageChart/action-types.js